import { Button, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import { isNative } from '@/lib/platform/platform';

/**
 * Registers the service worker (web/PWA only — native builds ship their assets
 * in the app bundle) and offers a reload when a new version is available.
 */
export function PwaUpdatePrompt() {
  const [update, setUpdate] = useState<null | (() => Promise<void>)>(null);

  useEffect(() => {
    if (isNative() || !('serviceWorker' in navigator) || import.meta.env.DEV) return;
    let cancelled = false;
    void import('virtual:pwa-register').then(({ registerSW }) => {
      if (cancelled) return;
      const updateSW = registerSW({
        onNeedRefresh: () => setUpdate(() => () => updateSW(true)),
      });
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Snackbar
      open={!!update}
      message="A new version of TradePrep is available."
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      action={
        <Button color="secondary" size="small" onClick={() => void update?.()}>
          Reload
        </Button>
      }
    />
  );
}
